__turbopack_context__.v({
  "CategoryGroup": "brzaCa_CategoryGroup",
});
